import { TabPane, Tabs } from '@lifebit-ai/lds'
import React from 'react'

import { useRequestsPage } from 'modules/requests/hooks/useRequestsPage'
import { RequestsTabKeys } from 'modules/requests/requestsTabKeys'

import * as styles from './RequestsNavbarHeader.styles'

const RequestsNavbarHeader = () => {
  const { activeTabKey, exportTabKey, exportTabName, isDataAccessTabEnabled, onSelectTab } = useRequestsPage()

  return (
    <styles.Container>
      <styles.TabsRow>
        <Tabs activeKey={activeTabKey} onChange={onSelectTab}>
          <TabPane tabName={exportTabName} tabKey={exportTabKey} />
          {isDataAccessTabEnabled ? <TabPane tabName="Data Access" tabKey={RequestsTabKeys.DataAccess} /> : null}
          <TabPane tabName="Imports" tabKey={RequestsTabKeys.Import} />
        </Tabs>
      </styles.TabsRow>
    </styles.Container>
  )
}

export default RequestsNavbarHeader
